import { render, staticRenderFns } from "./createhelp.vue?vue&type=template&id=05bc2cce"
import script from "./createhelp.vue?vue&type=script&lang=js"
export * from "./createhelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports